export function toArray() {
  let cookies = document.cookie.split(';');
  cookies = cookies.map((cookieString) => {
    const cookie = cookieString.split('=');
    return {
      name: cookie[0] || '',
      value: cookie[1] || '',
    };
  });
  return cookies;
}

export function toObject() {
  const cookies = document.cookie.split(';');
  const cookieObject = {};
  cookies.forEach((cookieString) => {
    const cookie = cookieString.split('=');
    if (cookie[0]) {
      cookieObject[cookie[0].trim()] = cookie[1];
    }
  });
  return cookieObject;
}

export function isExist(name) {
  const cookies = document.cookie.split(';');
  let exist = false;
  for (let i = cookies.length - 1; i >= 0; i--) {
    const cookie = cookies[i].split('=');
    if (cookie[0] && cookie[0].trim() === name) {
      exist = true;
      break;
    }
  }
  return exist;
}

export function getValue(name) {
  const cookies = toObject();
  return cookies[name];
}

export function setCookie(name, value, expires, domain, path) {
  document.cookie = `${name}=${value};${expires ? `expires=${expires}` : '' };domain=${domain};path=${path}`;
}

export function removeCookie(name) {
  document.cookie = `${name}=;expires=${(new Date().toUTCString())};`;
}

export default {
  toObject,
  toArray,
  getValue,
  isExist,
  removeCookie,
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/utils/cookie.js
 **/